import { Loader } from "@anna-money/anna-web-ui";
import { Status, Wrapper } from "@googlemaps/react-wrapper";
import { observer } from "mobx-react-lite";
import type { FC, ReactElement } from "react";
import { useServices } from "../../../../../app/appServices";
import { ErrorView } from "../../../../../components/errorView/errorView";
import styles from "./mapComponent.module.scss";

const londonPlaceId = "ChIJdd4hrwug2EcRmSrV3Vo6llI";

type MapComponentType = {
  placeId: Nullable<string>;
};

export const MapComponent: FC<MapComponentType> = observer(({ placeId }) => {
  const { config } = useServices();
  const render = (status: Status): ReactElement => {
    if (status === Status.FAILURE) {
      return <ErrorView />;
    }
    return <Loader />;
  };

  return (
    <Wrapper libraries={["places", "geometry"]} apiKey={config.googleMapsApiKey ?? ""} language="en" render={render}>
      <iframe
        className={styles.mapContainer}
        width="450"
        height="250"
        style={{ border: 0 }}
        title="some title"
        referrerPolicy="no-referrer-when-downgrade"
        src={`https://www.google.com/maps/embed/v1/place?key=${config.googleMapsApiKey ?? ""}&q=place_id:${
          placeId || londonPlaceId
        }`}
        allowFullScreen
      />
    </Wrapper>
  );
});
